import { Drawer, HeadingRow } from "cai-fusion";

import { ReactComponent as IconCloseSquare } from "../../../../../images/close-square.svg";

import { useTransientVisibility } from "../../../../fusion/Contexts/VisualContext";
import { useSiftV2 } from "../../../contexts/siftV2Context";

const OpportunityHistoryDrawer = () => {

    const { hide, visibilityStates } = useTransientVisibility();
    const { placeholderTimeline } = useSiftV2();

    return (
        <Drawer
            clickOutsideToClose
            isHidden={!visibilityStates.OpportunityHistoryDrawer}
            id="sharing-drawer"
            onClose={() => hide('OpportunityHistoryDrawer')}
            header={
                <HeadingRow
                    title="History"
                    eyebrow="Opportunity"
                    size={3}
                >
                    <div className="m-icon-row m-icon-row--right-align">
                        <a
                            id="drawerCloseBtn"
                            className="a-icon m-icon-row__icon"
                            title="Close Associate Details"
                            onClick={(e) => {
                                e.preventDefault();
                                hide('OpportunityHistoryDrawer')
                            }}
                        >
                            <IconCloseSquare className="a-icon__img" />
                        </a>
                    </div>
                </HeadingRow>
            }
        >
            <form className="o-form l-mt-sm">
                <div className="row l-mb-xs">
                    <div className="col-md-12">
                        <ul className="o-timeline">
                            {placeholderTimeline.map((timelineItem) => (
                                <TimelineItem 
                                    Icon={IconCloseSquare}
                                    timestamp={new Date(timelineItem.timestamp).toLocaleString()}
                                    title={timelineItem.title}
                                    description={timelineItem.description}
                                />
                            ))}
                        </ul>
                    </div>
                </div>
            </form>
        </Drawer>
    )
}

const TimelineItem = ({Icon, timestamp, title, description}) => {
    return (
        <li className="o-timeline__item">
            <div className="o-timeline__icon-wrapper">
                <Icon className="o-timeline__icon" />
            </div>
            <div className="o-timeline__content">
                <div className="o-timeline__when">{timestamp}</div>
                <div className="o-timeline__title">{title}</div>
                <div className="o-timeline__description">{description}</div>
            </div>
        </li>
    )
}

export default OpportunityHistoryDrawer;